import React, { useEffect, useState } from 'react';
import { GeoJSON } from 'react-leaflet';
import type { FeatureCollection } from 'geojson';
import { BOUNDARIES_PANE } from '../MapPanes';

// Contorno do Brasil (johan/world.geo.json, repo com GeoJSON de cada pais).
// Servido via jsDelivr para cache global. Quando o projeto puder hospedar
// localmente, mover para public/mock/brazil.geojson.
const BRAZIL_COUNTRY_URL = 'https://cdn.jsdelivr.net/gh/johan/world.geo.json@master/countries/BRA.geo.json';

const lineStyle = {
  color: '#ffffff', // tema: fixo (desenhado sobre o mapa, igual nos dois temas)
  weight: 1.5,
  opacity: 0.9,
  fillOpacity: 0,
  interactive: false,
};

export default function BrazilCountryLayer() {
  const [data, setData] = useState<FeatureCollection | null>(null);

  useEffect(() => {
    let canceled = false;
    fetch(BRAZIL_COUNTRY_URL)
      .then((r) => r.json())
      .then((json: FeatureCollection) => { if (!canceled) setData(json); })
      .catch(() => { if (!canceled) setData(null); });
    return () => { canceled = true; };
  }, []);

  if (!data) return null;

  return <GeoJSON data={data} style={() => lineStyle} pane={BOUNDARIES_PANE} />;
}
